<template>
  <div id="app">
    <router-view name="head"></router-view>
    <router-view />
    <router-view name="footer"></router-view>
    <!-- <AddToHomeScreen/> -->
  </div>
</template>
<style>
@import url("//unpkg.com/element-ui@2.13.0/lib/theme-chalk/index.css");
</style>
<script>
// import AddToHomeScreen from './components/addTohome.vue'
 export default {
    name: 'App',
    components: {
      // AddToHomeScreen
    },
    mounted(){
    },
    methods: {
    }
  };
</script>

